// src/styles/StyledUnit/StyledDecisionTable.js
import styled from "styled-components";


export const StyledQuestionInput = styled.input`
  margin-left: 1rem;
  width: 100%;
`;

export const StyledDecisionTableHeader = styled.div`
	margin-bottom: 1rem;
	padding: 1.1rem 2rem;

	background-color: #dde5ef;
	border-bottom: 1px solid #4d6382;

	display: flex;
	align-items: center;

	& > span {
		color: #283239;
		font-size: 1.2rem;
		font-weight: 500;
		display: block;
	}

	& > span:nth-child(1) {
		width: 10%;
	}

	& > span:nth-child(2) {
		width: 80%;
	}

	& > span:nth-child(3) {
		width: 10%;
		display: flex;
		justify-content: flex-end;
	}
`;

export const StyledDecisionTableRow = styled.div`
	margin: 0.4rem 0;
	padding: 0.6rem 1.8rem;

	display: flex;
	align-items: center;
	background-color: #ffffff;

	& span {
		font-size: 1.4rem;
		font-weight: 300;
	}

	& > span:nth-child(1) {
		width: 10%;
	}

	& > span:nth-child(2) {
		width: 80%;
		overflow: hidden;
	}

	& > div {
		width: 10%;
		display: flex;
		align-items: center;
		justify-content: flex-end;

		& img {
			height: 1.6rem;
			margin-left: 1rem;
			cursor: pointer;
		}
	}

	& input {
		width: 100%;
		margin-bottom: 0;
	}
`;
